import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import PageLayout from './layout/PageLayout';
import abbreviations from '../data/cotadAbv';

const COTADPage = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(current => (current + 1) % abbreviations.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);

  return (
    <PageLayout>
      <div className="max-w-4xl mx-auto px-4 py-16">
        <h1 className="text-4xl font-bold text-center mb-8">What does COTAD mean?</h1>
        
        <div className="text-center mb-12">
          <p className="text-xl mb-8">
            The truth is, we embrace multiple interpretations of our name. 
            Like many meaningful things in life, its meaning can be personal to you.
          </p>
          
          {/* Updated container with better padding and spacing */}
          <div className="my-2 sm:my-4 relative w-full">
            <AnimatePresence mode="wait">
              <motion.div
                key={currentIndex}
                className="w-full"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.7 }}
              >
                <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold text-gradient py-2 mb-0 break-words">
                  {abbreviations[currentIndex]}
                </h2>
              </motion.div>
            </AnimatePresence>
          </div>

          <p className="text-lg text-text-secondary">
            We invite you to choose the interpretation that resonates most with you.
            What matters most is not what COTAD originally stood for, but what it means to you
            and how it reflects our mission of creating an inclusive and supportive community.
          </p>
        </div>
      </div>
    </PageLayout>
  );
};

export default COTADPage;